import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Film, Loader2, Play, X } from "lucide-react";
import api from "../lib/api";

export const isVideo = (ct) => (ct || "").toLowerCase().startsWith("video/");
const MAX_BLOB_THUMB = 25 * 1024 * 1024;
const cache = new Map();

// URL riproducibile: firmato (B2/Wasabi/GCS, supporta lo scorrimento) oppure blob locale.
export const videoSrc = (pid, a, forThumb = false) => {
  const key = `${a.id}:${forThumb ? "t" : "p"}`;
  if (!cache.has(key)) {
    cache.set(key, (async () => {
      try {
        const { data } = await api.get(`/studio/pratiche/${pid}/allegati-files/${a.id}/content-url`);
        if (data?.url) return data.url;
        if (forThumb && (a.size || 0) > MAX_BLOB_THUMB) return null;
        const r = await api.get(`/studio/pratiche/${pid}/allegati-files/${a.id}/content`, { responseType: "blob" });
        return URL.createObjectURL(r.data);
      } catch { cache.delete(key); return null; }
    })());
  }
  return cache.get(key);
};

export const VideoThumb = ({ pid, a, className = "", iconClass = "h-10 w-10" }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => { let on = true; videoSrc(pid, a, true).then((u) => { if (on) { if (u) setUrl(u); else setFailed(true); } }); return () => { on = false; }; }, [pid, a]);
  return (
    <div className={`relative w-full h-full bg-black flex items-center justify-center ${className}`} data-testid={`video-thumb-${a.id}`}>
      {url && !failed ? (
        <video src={`${url}#t=0.5`} preload="metadata" muted playsInline onError={() => setFailed(true)} className="w-full h-full object-cover pointer-events-none" />
      ) : failed ? <Film className={`${iconClass} text-slate-400`} /> : <Loader2 className="h-5 w-5 animate-spin text-slate-500" />}
      <span className="absolute inset-0 flex items-center justify-center pointer-events-none"><span className="rounded-full bg-black/60 p-1.5"><Play className="h-4 w-4 text-white fill-white" /></span></span>
    </div>
  );
};

export const VideoPlayer = ({ pid, file, onClose }) => {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { videoSrc(pid, file).then((u) => (u ? setUrl(u) : setErr(true))); }, [pid, file]);
  useEffect(() => {
    const k = (e) => { if (e.key === "Escape") { e.stopPropagation(); onClose(); } };
    window.addEventListener("keydown", k, true);
    return () => window.removeEventListener("keydown", k, true);
  }, [onClose]);
  return createPortal(
    <div className="fixed inset-0 z-[9999] bg-black/90 flex flex-col items-center justify-center p-4 pointer-events-auto" onClick={onClose} data-testid="video-player-modal">
      <button type="button" onClick={onClose} className="absolute top-4 right-4 text-white/80 hover:text-white" aria-label="Chiudi" data-testid="video-player-close"><X className="h-7 w-7" /></button>
      {err ? <p className="text-white text-sm">Video non disponibile.</p> : !url ? <Loader2 className="h-8 w-8 animate-spin text-white" /> : (
        <video src={url} controls autoPlay playsInline onClick={(e) => e.stopPropagation()} onError={() => setErr(true)} className="max-h-[80vh] max-w-[90vw] rounded shadow-2xl bg-black" data-testid="video-player" />
      )}
      <div className="mt-3 text-white text-sm bg-black/50 px-3 py-1 rounded max-w-[90vw] truncate">{file.nome}</div>
    </div>,
    document.body,
  );
};
